import {IApiModel} from 'app/original-models/api-model.interface';
import moment from 'moment';
import {environment} from 'environments/environment';
import { enc, HmacSHA256 } from 'crypto-js';

export class IntercomSettings implements IApiModel<IntercomSettings> {
    userName: string;
    userHash: string;
    userId: string;
    userEmail: string;
    userCreationDate: Date;
    subscription: string;
    companyName: string;
    fiscalYearEnding: string;
    accountsCount: number;
    transactionsCount: number;
    expectedTransactionsCount: number;
    plansCount: number;
    company: { id: null, name: '' };
    isCompany: boolean;

    constructor(init?: Partial<IntercomSettings>) {
        Object.assign(this, init);
    }

    getApiModel(): Object {
        throw new Error('Not supported');
    }

    getIntercomModel(appId: string, companyId: number, isCompany: boolean): Object {
        let companyData = isCompany ?  {
            id: companyId.toString(),
            name: this.companyName
        } : null;
        let groupData = !isCompany ?  {
            id: companyId.toString(),
            name: this.companyName
        } : null;
        let model = {
            app_id: appId,
            name: this.userName,
            user_id: this.userId,
            email: this.userEmail,
            created_at: this.userCreationDate,
            subscription: this.subscription,
            company: companyData,
            group: groupData,
            fiscal_year: this.fiscalYearEnding,
            accounts: this.accountsCount,
            transactions: this.transactionsCount,
            expected_transactions: this.expectedTransactionsCount,
            plans: this.plansCount,
            user_hash: this.userHash
        }
        return model;
    }

    setFromApiModel(apiModel: any, isCompany: boolean): this {
        this.userName = apiModel.name;
        this.userId = apiModel.user_id;
        this.userEmail = apiModel.email;
        this.userCreationDate = moment(apiModel.created_at, 'YYYY-MM-DD').toDate();
        this.subscription = apiModel.subscription;
        this.companyName = apiModel.company;
        this.fiscalYearEnding = apiModel.fiscal_year;
        this.accountsCount = apiModel.accounts;
        this.transactionsCount = apiModel.transactions;
        this.expectedTransactionsCount = apiModel.expected_transactions;
        this.plansCount = apiModel.plans;
        this.isCompany = isCompany;


        let hash = this.getUserHash(this.userId);
        this.userHash = hash;
        return this;
    }

    setFromApiModelFromGroup(apiModel: any, userId: string): this {
        this.userName = apiModel.tenant ? `${apiModel.tenant.first_name} ${apiModel.tenant.last_name}` : '';
        this.userId = userId;
        this.userEmail = apiModel.tenant ? apiModel.tenant.email : '';
       // this.userCreationDate = moment(apiModel.created_at, 'YYYY-MM-DD').toDate();
      //  this.subscription = apiModel.subscription;
        this.companyName = apiModel.name;
        this.fiscalYearEnding = apiModel.fiscalYearEnding;
       // this.accountsCount = apiModel.accounts;
        //this.transactionsCount = apiModel.transactions;
        //this.expectedTransactionsCount = apiModel.expected_transactions;
        //this.plansCount = apiModel.plans;
        this.isCompany = false;

        let hash = this.getUserHash(this.userId);
        this.userHash = hash;
        return this;
    }

    getUserHash(strToHash: string) {
        let salt = environment.intercom.salt;
        let hash = HmacSHA256(strToHash, salt);
        let hashedResult = hash.toString(enc.Hex);
        return hashedResult;
    }
}
